import * as S from './styles'
import { useGuideTourButton } from './useGuideTourButton'

export const GUIDE_TOUR_BUTTON_LABEL = 'Exibir tutorial'

export const GuideTourButton = () => {
  const { isVisible, onClick } = useGuideTourButton()

  if (!isVisible) {
    return null
  }

  return (
    <S.GuideTourButtonElement
      type="button"
      data-testid="guide-tour-button"
      onClick={onClick}
    >
      {GUIDE_TOUR_BUTTON_LABEL}
    </S.GuideTourButtonElement>
  )
}
